<template>
  <v-layout justify-center>
    <v-layout
      v-if="loading"
      justify-center
      align-center
      style="height: 100vh; width: 100vw"
    >
      <v-progress-circular indeterminate color="blue"></v-progress-circular>
    </v-layout>
    <div v-else class="mt-8">
      <div class="font-weight-bold text-center mb-4" style="font-size: larger">
        契約書表示
      </div>
      <v-container
        class="d-flex justify-space-betweend-flex justify-space-between"
      >
        <v-btn @click="navigateBack">戻る</v-btn>
        <v-btn class="blue lighten-1" @click="dialog = true">印刷する</v-btn>
      </v-container>
      <v-container
        class="d-flex justify-center"
        style="padding: 0; width: 100%; min-width: 700px"
      >
        <canvas ref="pdfCanvas"></canvas>
      </v-container>
    </div>

    <!-- Choose printed document -->
    <v-dialog width="460" v-model="dialog" persistent>
      <template>
        <v-card title="Dialog">
          <v-card-text class="pt-4 text-center">
            <v-checkbox v-model="isPrintRules" label="重要事項・概要書面" />
            <v-checkbox
              v-model="isPrintContract"
              class="mt-0"
              label="契約書書面"
            />
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn class="info" @click="printPdf">印刷する</v-btn>
            <v-btn @click="handleCloseDialog">閉じる </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: "ContractReview",

  data: () => {
    return {
      isShow: false,
      pdfBytes: null,
      pdfLoaded: false,
      pdfCanvas: null,
      pdfjsLib: null,
      loading: true,
      dialog: false,
      isPrintContract: true,
      isPrintRules: true,
    };
  },

  created() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);
    this.tempContractId = this.$route.params.tempContractId;
    this.handleShow();
  },

  beforeRouteLeave(to, from, next) {
    if (
      to.name !== "customer_contract_input" &&
      to.name !== "customer_contract_detail"
    ) {
      const answer = window.confirm(
        "入力した情報が消去される可能性があります。続行してもよろしいですか？"
      );
      if (answer) {
        next();
        this.preventBackNavigation();
        this.$store.dispatch("updateContractTempData", {});
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
  mounted() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },

  methods: {
    handleBeforeUnload(event) {
      event.returnValue =
        "入力した情報が消去される可能性があります。続行してもよろしいですか？";
      event.preventDefault();
      return event.returnValue;
    },
    preventBackNavigation() {
      window.history.pushState(null, "", window.location.href);
      window.addEventListener("popstate", () => {
        window.history.pushState(null, "", window.location.href);
      });
    },

    async handleShow() {
      this.isShow = !this.isShow;
      this.loadPdf().then(() => this.renderPdf());
    },

    async loadPdf() {
      const pdfData = await this.getPdfData();
      this.pdfCanvas = this.$refs.pdfCanvas;
      this.pdfBytes = pdfData;
    },

    async getPdfData() {
      const loadingPdfBytes = await this.$axios.get(
        `/api/v1/course-contract/${this.tempContractId}/temp`,
        {
          responseType: "arraybuffer",
        }
      );
      this.loading = false;
      return loadingPdfBytes.data;
    },

    async renderPdf() {
      const pdfjsLib = window["pdfjs-dist/build/pdf"];
      pdfjsLib.GlobalWorkerOptions.workerSrc =
        "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.worker.min.js";
      const pdf = await pdfjsLib.getDocument({ data: this.pdfBytes }).promise;
      const page = await pdf.getPage(1);

      const viewport = page.getViewport({ scale: 1.5 });

      this.pdfCanvas.height = viewport.height;
      this.pdfCanvas.width = viewport.width;

      const context = this.pdfCanvas.getContext("2d");

      const renderContext = {
        canvasContext: context,
        viewport: viewport,
      };

      page.render(renderContext);
      this.pdfLoaded = true;
    },

    async printPdf() {
      try {
        if (!this.isPrintContract && !this.isPrintRules) {
          alert("印刷する書面を選択してください。");
        } else {
          const id = this.$route.query.contractId;
          const res = id
            ? await this.$axios.put("/api/v1/course-contract/save", {
                contract_id: id,
                temp_contract_id: this.tempContractId,
              })
            : await this.$axios.post("/api/v1/course-contract/save", {
                temp_contract_id: this.tempContractId,
              });
          this.$store.dispatch("updateContractTempData", null);
          this.$router.push({
            name: "customer_contract_detail",
            params: { courseId: res.data.contract_id },
            query: {
              isPrint: true,
              isPrintContract: this.isPrintContract,
              isPrintRules: this.isPrintRules,
            },
          });
        }
      } catch (error) {
        console.error(error);
      }
    },

    navigateBack() {
      this.$router.go(-1);
    },

    handleCloseDialog() {
      this.dialog = false;
      this.isPrintContract = true;
      this.isPrintRules = true;
    },
  },
};
</script>

<style scoped>
canvas {
  border: 1px solid black;
  margin-bottom: 20px;
  width: 100%;
}
</style>
